var util = angular.module('gymsystem.util');
util.factory('dropdownmodal', ['$modal', function ($modal) {
        return function (option) {
            return new Promise(function (resolve, reject) {
                var tpl = function (html) {
                    var tpl = document.createElement('div');
                    tpl.innerHTML = html;
                    return tpl.firstElementChild;
                };
                var el = tpl("\n        <div class=\"dropdown open\" style=\"display: inline\">\n          <ul class=\"dropdown-menu\" aria-labelledby=\"dLabel\">\n          </ul>\n        </div>");
                option.items.forEach(function (n, i) {
                    var it = tpl("<li style=\"cursor: pointer\"><a>".concat(n.name, "</a></li>"));
                    el.firstElementChild.appendChild(it);
                    it.addEventListener('click', function (e) {
                        e.stopPropagation();
                        close(true);
                        resolve(n);
                    });
                });
                var label = option.target;
                var parent = label.parentNode;
                parent.insertBefore(el, label);
                var close = function (done) {
                    document.body.removeEventListener('click', close);
                    el.remove();
                    if (done !== true)
                        reject();
                };
                setTimeout(function () {
                    document.body.addEventListener('click', close);
                }, 10);
            });
        };
    }]);
